import { inject, Injectable, signal } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {
  OpenQuoteRequestsItem,
} from '@sbd-account-portal/app/modules/dashboard/open-quote-requests-widget/quote-requests.types';
import { BondsListItem } from '@sbd-account-portal/app/modules/bonds/bonds-list/bonds-list.type';
import { QuoteRequestsListItem } from '@sbd-account-portal/app/modules/quote/requests-list/quote-request.type';
import { CIPXDrawerManagerService } from '@sbd-doug-frontend/shared/lib/ui/drawer/drawer-manager.service';
import { BondCancellationWrapperComponent } from '@sbd-account-portal/app/modules/bond-cancellation/bond-cancellation-wrapper/bond-cancellation-wrapper.component';

@Injectable({
  providedIn: 'root',
})
export class CIPXBondCancellationService {
  private _httpClient = inject(HttpClient);
  item = signal<OpenQuoteRequestsItem | BondsListItem | QuoteRequestsListItem>(null);
  private _drawerManagerService = inject(CIPXDrawerManagerService);
  cancellationRequested = signal<boolean>(false);

  openDrawer() {
    this._drawerManagerService.openDrawer(BondCancellationWrapperComponent, {
      data: {
        title: 'Request Bond Cancellation',
        qr: this.item(),
      },
    });
  }

  clear() {
    this.item.set(null);
  }
}

